import {
	Button,
	Divider,
	Grid,
	TextField,
	Typography,
} from "@material-ui/core";
import { isNil } from "lodash-es";
import React, { useEffect, useState } from "react";
import { ErrorModal } from "../../../../../../../components/modals/error-modal";
import MesfModal from "../../../../../../../components/modals/modal.mesf";
import { ButtonWithLoading } from "../../../../../../../components/shared/buttons/button-with-loading";
import { View } from "../../../models/TrendingModels";
import { upsertView } from "../../../repository/TrendingRepository";
import { useTrendingStyles } from "../../../styles/TrendingStyles";

interface Props {
	open: boolean;
	handleClose: (shouldUpdate: boolean) => void;
	view: View | null;
}

export const EditViewModal = ({ open, handleClose, view }: Props) => {
	const classes = useTrendingStyles();

	const [newName, setNewName] = useState("");
	const [isPublic, setIsPublic] = useState(true);

	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState("");

	const handleSubmit = async () => {
		setIsLoading(true);
		if (!isNil(view)) {
			const resp = await upsertView(view.ViewId, newName, isPublic);
			if (!resp.ok) {
				setError(resp.message);
			} else {
				handleClose(true);
			}
		}

		setIsLoading(false);
	};

	const handleChangeInput = (e: any) => {
		e.preventDefault();
		const name = e.target.value;
		setNewName(name);
	};

	const handleCheck = () => setIsPublic(!isPublic);

	useEffect(() => {
		if (view) {
			setIsPublic(view.IsPublic);
			setNewName(view.ViewName);
		}
	}, [view]);

	return (
		<>
			<MesfModal
				open={open}
				handleClose={() => handleClose(false)}
				maxWidth={"xl"}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
				title="Update View"
			>
				<Divider />

				<MesfModal.Content>
					{!isNil(view) ? (
						<Grid container spacing={5} style={{ padding: "2rem" }}>
							<Grid
								item
								md={12}
								xs={12}
								style={{ padding: "10px", width: "100%" }}
							>
								<TextField
									required
									className={classes.inputCustom}
									id="viewName"
									label="Name"
									variant="outlined"
									onChange={handleChangeInput}
									value={newName}
								/>
							</Grid>
							<Grid
								item
								md={12}
								xs={12}
								style={{ paddingTop: "2rem" }}
								className={classes.isPublicCheckbox}
							>
								<label>
									<input
										type="checkbox"
										checked={isPublic}
										onChange={handleCheck}
									/>
									<Typography>Public</Typography>
								</label>
							</Grid>
						</Grid>
					) : (
						<Typography>ERROR: No view detected, please select one</Typography>
					)}
				</MesfModal.Content>
				<Divider />
				<MesfModal.Actions>
					<Grid
						container
						spacing={1}
						style={{
							display: "flex",
							alignItems: "flex-end",
							justifyContent: "flex-end",
						}}
					>
						<Grid item>
							<Button
								variant="outlined"
								color="secondary"
								onClick={() => handleClose(false)}
							>
								Cancel
							</Button>
						</Grid>
						<Grid item>
							{!isNil(view) ? (
								<ButtonWithLoading
									variant="contained"
									color="primary"
									onClick={handleSubmit}
									isLoading={isLoading}
								>
									Update
								</ButtonWithLoading>
							) : (
								<Button
									variant="contained"
									style={{ marginRight: "1rem" }}
									color="primary"
									onClick={() => handleClose(false)}
								>
									Ok
								</Button>
							)}
						</Grid>
					</Grid>
				</MesfModal.Actions>
			</MesfModal>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
